import { render, staticRenderFns } from "./SelfServiceBankInformation.vue?vue&type=template&id=5b74ed92&scoped=true"
import script from "./SelfServiceBankInformation.vue?vue&type=script&lang=js"
export * from "./SelfServiceBankInformation.vue?vue&type=script&lang=js"
import style0 from "./SelfServiceBankInformation.vue?vue&type=style&index=0&id=5b74ed92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b74ed92",
  null
  
)

export default component.exports